"use client";
import React from "react";
import HeroText, { HeroTextProps } from "./HeroText";
import HeroImage, { HeroImageProps } from "./HeroImage";
import HeroCentered from "./HeroCentered";
import HeroSideBySide from "./HeroSideBySide";

export type HeroButton = {
  text?: string;
  href?: string;
  variant?: "primary" | "secondary";
};

export type HeroProps = HeroTextProps &
  HeroImageProps & {
    layout?: "centered" | "left-right" | "right-left";
    description?: string;
    showBackgroundGradient?: boolean;
    titleGradient?: "purple-cyan" | "blue-teal";
  };

const Hero: React.FC<HeroProps> = ({
  title,
  subtitle,
  description,
  buttons,
  imageUrl,
  layout = "centered",
  showBackgroundGradient,
  titleGradient = "purple-cyan",
}) => {
  // Render based on layout type
  if (layout === "centered") {
    return (
      <HeroCentered
        title={title}
        subtitle={subtitle}
        buttons={buttons}
        imageUrl={imageUrl}
        showBackgroundGradient={showBackgroundGradient}
      />
    );
  }

  // Side-by-side layouts (left-right or right-left)
  return (
    <HeroSideBySide
      title={title}
      description={description}
      subtitle={subtitle}
      buttons={buttons}
      imageUrl={imageUrl}
      layout={layout}
      showBackgroundGradient={showBackgroundGradient}
      titleGradient={titleGradient}
    />
  );
};

export default Hero;

// Re-export sub-components for backwards compatibility
export { default as HeroText } from "./HeroText";
export { default as HeroImage } from "./HeroImage";
export { default as HeroCentered } from "./HeroCentered";
export { default as HeroSideBySide } from "./HeroSideBySide";

